import React, { Component } from 'react';

import { Form, TreeSelect } from 'antd';

import service from './../../services';
const FormItem = Form.Item;

class NameShow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: undefined,
            data: [],
            maps: {},
            keys: ['1']
        };
    }

    componentDidMount() {
        this.querySearch();
    }

    querySearch() {
        return service.evals.querySearchAllTree()
        .then((data) => {

            this.setState({
                value: this.props.value ? this.props.value : []
            });
            this.setState(data);
            this.setState({
                keys: [data.data[0].key]
            });
        });
    }

    componentWillReceiveProps(nextProps) {

        if(nextProps.hasOwnProperty('value')) {
            this.setState({
                value: nextProps.value ? nextProps.value  : [],
            });
        }
    }

    handleChange(value) {
        this.setState({
            value: value
        });
        let targetName = [];
        for(let i = 0 ; i < value.length ; i++){
            targetName.push(this.state.maps[value[i]])
        }
        if(this.props.handleChange) {
            this.props.handleChange({
                targetIds: value,
                targetName: targetName
            });
        }
    }

    render() {
        const {label,style , name, notAllowClear,} = this.props;
        const { data, value } = this.state;
        return (
            <FormItem label={label || "评价指标"}>
                {
            
                    <TreeSelect
                    multiple
                    allowClear={notAllowClear === true ? false : true}
                    value={value}
                    treeData={data}
                    dropdownClassName="org-tree-select"
                    placeholder='请选择...'
                    treeDefaultExpandedKeys={this.state.keys}
                    style= {style || {width: 240}}
                    onChange={(value) => {
                        if(value) {
                            this.handleChange(value);
                        } else {
                            this.handleChange(value);
                        }
                    }}
                    ></TreeSelect>
                }

            </FormItem>
        );
    }
}

export default NameShow;